import { V3CTDirectionSettings } from 'ngx-modbus';

import { LeanFormSchema, fieldRef } from '../types/config-form.types';

export const CT_DIRECTION_FORM: LeanFormSchema = {
  version: '1',
  id: 'ct-direction',
  name: 'CT Direction & Emergency Shutdown',
  sections: [{
    id: 'ct-direction',
    labelKey: 'ctDirectionSettings',
    registerTable: 'V3CTDirectionSettings',
    validityMask: 'AddressMask_Config_Basic2',
    fields: [
      fieldRef(V3CTDirectionSettings, 'CT_Direction'),
      fieldRef(V3CTDirectionSettings, 'Emergency_Shutdown'),
    ],
  }],
};
